import { TableCell, TableRow } from '@mui/material';
import { FileInfoDto, IPagingData } from '@sr/dto';
import { GridLayout } from 'shared/ui/grid-layout';
import { IRemotePagedCollection } from 'utils/remote-paged-collection.hook';
import { LinkToFile } from 'shared/ui/links/link-to-file';
import FilePresentIcon from '@mui/icons-material/FilePresent';
import { formatShortDate } from 'utils/date-format-helpers';
import { formatPersonPruning } from 'utils/person-format-helpers';


type Props = {
  collection: IRemotePagedCollection<FileInfoDto>,
  paging?: IPagingData;
  onChangePaging?: (paging: IPagingData) => void;
};

export const FileList = ({ collection, paging, onChangePaging }: Props) => {
  return (
    <>
      <GridLayout<FileInfoDto>
        columns={['Файл', 'Размер, Кб', 'Приватность', 'Тип', 'Кто зарузил', 'Дата загрузки']}
        items={collection.collection.items}
        totalItemsCount={collection.collection.totalItemsCount}
        isLoading={collection.isLoading}
        error={collection.error}
        pagingData={paging}
        onChangePaging={onChangePaging}
        itemRender={(item) =>
          <FileList.Row
            key={item.id}
            file={item} />}
        noItemsText='Список файлов пуст'
      />
    </>);
};


type RowProps = {
  file: FileInfoDto,
};

FileList.Row = (props: RowProps) => {
  const { file } = props;

  return (
    <>
      <TableRow key={file.id} >
        <TableCell component="th" scope="row">
          <LinkToFile key = {file.id}
            file={{ id: file.id, fileName: file.fileName, size: Number(file.size) }}
            icon={<FilePresentIcon/>}/>
        </TableCell>
        <TableCell align='center'>{file.size}</TableCell>
        <TableCell>{file.isPrivate && '✅'}</TableCell>
        <TableCell>{file.mimetype}</TableCell>
        <TableCell align='center'>{file.uploadedBy && formatPersonPruning(file.uploadedBy)}</TableCell>
        <TableCell>{formatShortDate(file.createdAt)}</TableCell>
      </TableRow>
    </>
  );
};
